import Vue from 'vue';
import Vuex from 'vuex';
import StorePlugin from './../../../plugin/StorePlugin';
import StoreFactory from './../../../factory/StoreFactory';
import { ENVIRONMENT } from './../../types';
import sessionModule from './loader';

Vue.config.productionTip = false;
Vue.use(Vuex);
Vue.use(StorePlugin, { Vuex });

const sessionModuleFactory = new StoreFactory(ENVIRONMENT, Vue);
sessionModuleFactory.load(sessionModule);

const store = sessionModuleFactory.register();

export default store;



// WEBPACK FOOTER //
// ./src/store/modules/environment/index.js